import { IUserAudio } from 'store/types/audio'

export const filterAudioBySearchValue = (
  items: IUserAudio[],
  searchValue: string
) => {
  return items.filter(item =>
    item.title.toLowerCase().includes(searchValue.toLowerCase())
  )
}

const removeSimilarAudios = (audios: IUserAudio[]) => {
  return audios.reduce(
    (acc, audio) => {
      if (!acc.find(item => item.path === audio.path)) {
        acc.push(audio)
      }
      return acc
    },
    <IUserAudio[]>[]
  )
}

export const mergeSearchResults = (
  libSounds: IUserAudio[],
  userSounds: IUserAudio[]
) => {
  return removeSimilarAudios([...libSounds, ...userSounds])
}
